import React       from 'react';
import Parameters  from './Parameters';
import Prices      from './Prices';
import Loading     from './Loading';
import Steps       from './Steps';

export default () => (
  <div>
    <Loading />
    <Steps />
    <div className="row">
      <div className="col-lg-4">
        <Parameters />
      </div>
      <div className="col-lg-8">
        <Prices />
      </div>
    </div>
  </div>
);
